export default __webpack_public_path__ + "static/media/shape3.fb694412.svg";